// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldChart = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.00065 1.3335C4.32065 1.3335 1.33398 4.32016 1.33398 8.00016C1.33398 11.6802 4.32065 14.6668 8.00065 14.6668C11.6807 14.6668 14.6673 11.6802 14.6673 8.00016C14.6673 4.32016 11.6807 1.3335 8.00065 1.3335ZM8.00065 5.8335C7.72732 5.8335 7.50065 5.60683 7.50065 5.3335C7.50065 5.06016 7.72732 4.8335 8.00065 4.8335C9.74732 4.8335 11.1673 6.2535 11.1673 8.00016C11.1673 9.74683 9.74732 11.1668 8.00065 11.1668C7.72732 11.1668 7.50065 10.9402 7.50065 10.6668C7.50065 10.3935 7.72732 10.1668 8.00065 10.1668C9.19398 10.1668 10.1673 9.1935 10.1673 8.00016C10.1673 6.80683 9.19398 5.8335 8.00065 5.8335ZM8.00065 13.1668C5.15398 13.1668 2.83398 10.8468 2.83398 8.00016C2.83398 7.72683 3.06065 7.50016 3.33398 7.50016C3.60732 7.50016 3.83398 7.72683 3.83398 8.00016C3.83398 10.3002 5.70065 12.1668 8.00065 12.1668C10.3007 12.1668 12.1673 10.3002 12.1673 8.00016C12.1673 5.70016 10.3007 3.8335 8.00065 3.8335C7.72732 3.8335 7.50065 3.60683 7.50065 3.3335C7.50065 3.06016 7.72732 2.8335 8.00065 2.8335C10.8473 2.8335 13.1673 5.1535 13.1673 8.00016C13.1673 10.8468 10.8473 13.1668 8.00065 13.1668Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldChart };
